import { LeadCallOutcome, LeadIntentFlag } from '../../../../Model/Lead';

const texts = {
  leadCallOutcome: {
    [LeadCallOutcome.NOT_ANSWERED]: 'Not Answered',
    [LeadCallOutcome.LOST]: 'Lost',
    [LeadCallOutcome.FOLLOW_UP]: 'Follow-Up',
    [LeadCallOutcome.WON]: 'Won',
    [LeadCallOutcome.PAYMENT_PENDING]: 'Payment Pending',
  },
  title: 'Record Lead Outcome',
  saveRecord: 'Save Record',
  outcomeNote: 'Outcome Note',
  lostReasonLabel: 'Lost Reason',
  lostReasonRequired: 'Please select a lost reason before saving',
  followUpReasonLabel: 'Follow-Up Reason',
  selectFollowUpReason: 'Select follow up reason',
  followUpReasonRequired: 'Please select a follow up reason before saving',
  leadOutcome: 'Lead Outcome',
  leadOutcomeRequired: 'Please select a lead outcome before saving',
  followUpDateTime: 'Next Follow-Up Date & Time',
  followUpDateRequired: 'Follow-up date and time is required',
  outcomeNoteRequired: 'Outcome note is required',
  success: 'Lead outcome saved successfully',
  somethingWentWrong: 'Something went wrong. Please try again later',
  noAnswer: 'Not answered',
  cancel: 'Cancel',
  attemptTypeLabel: 'What happened when you called?',
  attemptTypeRequired: 'Please select what happened when you called before saving',
  previousAttemptsLabel: 'Previous Call Attempts',
  maxAttemptsReached: 'Maximum of 2 call attempts already recorded for this lead',
  loadingRecentOutcomes: 'Loading recent call outcomes. Please try again in a moment.',
  attemptTypeOption: {
    RANG: 'Phone rang (no answer)',
    VOICEMAIL: 'Went to voicemail',
  },
  autoLostWarning: 'This is the 2nd unanswered attempt. Saving will automatically mark this lead as Lost'
    + ' with a "Not Serious" reason. This cannot be undone.',
  autoLostConfirmLabel: 'I understand this lead will be permanently marked as Lost',
  autoLostConfirmRequired: 'Please confirm you understand the lead will be marked as Lost before saving',
  intentFlagLabel: 'Client Intent Flag',
  intentFlagRequired: 'Please select a client intent flag before saving',
  intentFlagOption: {
    [LeadIntentFlag.GREEN]: 'Green — paid without friction, clear intent, no hesitation',
    [LeadIntentFlag.AMBER]: 'Amber — converted with reservations (affordability, trial language, objections)',
    [LeadIntentFlag.RED]: 'Red — exit-seeking before starting (cancel/pause questions, travel or disruption)',
  },
};

export default texts;
